import { Paper, Stack, Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { PropsWithChildren, ReactNode } from "react"

const useStyles = makeStyles()((theme) => ({
    container: {
        borderRadius: theme.spacing(1.5),
        backgroundColor: theme.palette.common.white,
        boxShadow: theme.shadows[3],
        padding: theme.spacing(1.5),
        display: "flex",
        flexDirection: "column",
    },
    header: {
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1.5),
    },
    grow: {
        flexGrow: 1,
        overflow: "auto",
    },
}))

type ToolBarContainerProps = PropsWithChildren<{
    renderToolbarLeftActions?: ReactNode
    renderToolbarRightActions?: ReactNode
}>

export const ToolBarContainer = ({
    renderToolbarLeftActions,
    renderToolbarRightActions,
    children,
}: ToolBarContainerProps) => {
    const { classes } = useStyles()

    return (
        <Paper className={classes.container}>
            {(renderToolbarLeftActions || renderToolbarRightActions) && (
                <Stack direction="row" justifyContent="space-between" alignItems="center" className={classes.header}>
                    <Stack direction="row" spacing={1}>
                        {renderToolbarLeftActions}
                    </Stack>
                    <Stack direction="row" spacing={1}>
                        {renderToolbarRightActions}
                    </Stack>
                </Stack>
            )}
            <Box className={classes.grow}>{children}</Box>
        </Paper>
    )
}
